import React from 'react';

function PromoCodesUserInfo() {
  return <div>Working progress</div>;
}

export default PromoCodesUserInfo;
